import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import service1 from './images/allimages/34.webp';
import service2 from './images/allimages/9.webp';
import service3 from './images/allimages/11.webp';
import service4 from './images/allimages/25.webp';
import service5 from './images/allimages/12.webp';
import service6 from './images/allimages/36.webp';
import service7 from './images/allimages/27.webp';
import service8 from './images/allimages/37.webp';
import './css/exploreservices.css';
import lined from "./images/hero/lined.png";
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../contexts/ContentContext';

const ExploreServices = () => {
  const { language } = useLanguage();
  const { content, getServices } = useContent();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const [visibleServices, setVisibleServices] = useState([]);
  const [services, setServices] = useState([]);

  // Load services from API
  useEffect(() => {
    const loadServices = async () => {
      if (content?.services && content.services.length > 0) {
        const apiServices = content.services.map(service => ({
          id: service.id,
          title: language === 'ar' ? service.title_ar : service.title_en,
          image: service.image_url ? (service.image_url.startsWith('http') ? service.image_url : `${process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net'}${service.image_url.startsWith('/') ? service.image_url : `/${service.image_url}`}`) : service1,
          description_ar: service.description_ar,
          description_en: service.description_en
        }));
        setServices(apiServices);
      } else {
        // Fallback to default services
        const defaultServices = [
          { id: 1, title: language === 'ar' ? 'إنشاء المباني وصيانتها' : 'Building Construction and Maintenance', image: service1 },
          { id: 2, title: language === 'ar' ? 'إنشاء و صيانة الطرق و الشوارع والارصفة' : 'Road, Street and Sidewalk Construction and Maintenance', image: service2 },
          { id: 3, title: language === 'ar' ? 'إنشاء وصيانة الجسور و الإنفاق' : 'Bridge and Tunnel Construction and Maintenance', image: service3 },
          { id: 4, title: language === 'ar' ? 'أعمال البنية التحية' : 'Infrastructure Works', image: service4 },
          { id: 5, title: language === 'ar' ? 'تجهيز المواقع' : 'Site Preparation', image: service5 },
          { id: 6, title: language === 'ar' ? 'اعمال الهدم' : 'Demolition Works', image: service6 },
          { id: 7, title: language === 'ar' ? 'تأجير المعدات والاليات الثقيلة' : 'Heavy Equipment and Machinery Rental', image: service7 },
          { id: 8, title: language === 'ar' ? 'أعمال القطع الصخري' : 'Rock Cutting Works', image: service8 }
        ];
        setServices(defaultServices);
      }
    };
    loadServices();
  }, [content, language]);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || !titleRef.current) return;

      const section = sectionRef.current;
      const sectionRect = section.getBoundingClientRect();
      const sectionTop = sectionRect.top;
      const sectionBottom = sectionRect.bottom;

      // Handle title sticky behavior
      const titleElement = titleRef.current;
      if (sectionTop <= 0 && sectionBottom > window.innerHeight / 2) {
        titleElement.classList.add('sticky');
      } else {
        titleElement.classList.remove('sticky');
      }

      // Handle service cards visibility
      const serviceCards = section.querySelectorAll('.service');
      const newVisibleServices = [];

      serviceCards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const cardTop = cardRect.top;
        const windowHeight = window.innerHeight;

        if (cardTop < windowHeight * 0.8) {
          newVisibleServices.push(index);
        }
      });

      setVisibleServices(newVisibleServices);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, [services]);

  const title = content?.exploreServices 
    ? (language === 'ar' ? content.exploreServices.title_ar : content.exploreServices.title_en)
    : (language === 'ar' ? 'اكتشف خدماتنا' : 'Discover Our Services');

  return (
    <section className='explore-services' ref={sectionRef}>
      <img src={lined} alt="explore-services" className="lined" />
      <div className='title' ref={titleRef}>
        <h2>{title}</h2>
      </div>
      <div className='container'>
        <div className='row'>
          {services.map((service, index) => (
            <div key={service.id} className='col-lg-6 col-md-6 col-sm-12 col-12'>
              <Link to={`/service/${service.id}`}>
                <div 
                  className={`service ${visibleServices.includes(index) ? 'visible' : ''}`}
                  style={{ transitionDelay: `${(index % 2) * 0.2}s` }}
                >
                  <h3>{service.title}</h3>
                  <img src={service.image} alt={`service${service.id}`} />
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExploreServices;